<template>
  <div class="estimate">
    <div class="title">专业就业排名</div>
    <div class="app">
      <div class="bd">
        <div class="bd-left">
          <template>
            <el-menu
              default-active="2"
              class="el-menu-vertical-demo"
              @open="handleOpen"
              :unique-opened="true"
            >
            <template v-for="cate in cateList">
              <el-submenu :index="cate.categoryCode" :key="cate.id">
                <template slot="title">
                  <span>{{ cate.categoryName }}</span>
                </template>
                <el-menu-item-group
                  v-for="proClass in proClassList"
                  :key="proClass.id"
                >
                  <el-submenu :index="proClass.professionClassCode">
                    <template slot="title">{{
                      proClass.professionClassName
                    }}</template>
                    <el-menu-item
                      :index="proInfo.code"
                      v-for="proInfo in proInfoList"
                      :key="proInfo.id"
                      @click="show(proInfo.name, $event)"
                      >{{ proInfo.name }}</el-menu-item
                    >
                  </el-submenu>
                </el-menu-item-group>
              </el-submenu>
            </template>
            </el-menu>
          </template>
        </div>

        <div class="bd-right">
          <div class="filter-line">
            <el-input
              class="filter-line__input"
              v-model="schoolParam"
              @clear="handleFilter"
              @keydown.enter="handleFilter"
              placeholder="请输入学校"
              :clearable="true"
            ></el-input>
            <el-button
              class="filter-line__confirm"
              @click="handleFilter"
              type="primary"
              >确定</el-button
            >
          </div>

          <!-- 输入时，实时更新查看更多按钮的文案 -->
          <div class="more" v-show="true" v-if="schoolParam || proName">
            <el-button type="text" @click="handleDetail"
              >查看更多关于{{ schoolParam
              }}<template v-if="schoolParam && proName">/</template
              >{{ proName }}的就业数据>></el-button
            >
          </div>

          <!-- 查询后，才更新查看更多按钮的文案 把 v-show 改成 true 生效 -->
          <div
            class="more"
            v-show="false"
            v-if="paramsWithData.school || paramsWithData.major"
          >
            <el-button type="text" @click="handleDetail"
              >查看更多关于{{ paramsWithData.school
              }}<template v-if="paramsWithData.school && paramsWithData.major"
                >/</template
              >{{ paramsWithData.major }}的数据>></el-button
            >
          </div>

          <el-container v-show="!isShowEmpty" style="height: 100%">
            <!-- <el-header class="title">专业就业信息</el-header> -->
            <!-- <el-divider></el-divider> -->
            <el-main>
              <el-row>
                <!-- 一行中有两个大小相同的列 -->
                <div v-show="type === 'school'">
                  <el-col :span="12" class="col1" key="1">
                    <div
                      id="leftSchool"
                      :style="{ width: '400px', height: '400%' }"
                    ></div>
                  </el-col>
                  <el-col key="2" :span="12" class="col2">
                    <div
                      id="rightSchool"
                      :style="{ width: '400px', height: '400%' }"
                    ></div>
                  </el-col>
                </div>
                <div v-show="type === 'both'">
                  <el-col key="3" :span="12" class="col1">
                    <div
                      id="leftBoth"
                      :style="{ width: '400px', height: '400%' }"
                    ></div>
                  </el-col>
                  <el-col key="4" :span="12" class="col2">
                    <div
                      id="rightBoth"
                      :style="{width: '400px', height: '400%' }"
                    ></div>
                  </el-col>
                </div>
                <div v-show="type === 'major'">
                  <el-col key="5" :span="12" class="col1">
                    <div
                      id="leftMajor"
                      :style="{ width: '400px', height: '400%' }"
                    ></div>
                  </el-col>
                  <el-col key="6" :span="12" class="col2">
                    <div
                      id="rightMajor"
                      :style="{ width: '400px', height: '400%' }"
                    ></div>
                  </el-col>
                </div>
              </el-row>
            </el-main>
          </el-container>

          <el-empty
            class="data-empty"
            :image-size="200"
            :description="emptyDescription"
            v-show="isShowEmpty"
            style="height: 100%"
          ></el-empty>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ForecastService from "../../api/forecast";
import estimate from "../../api/configuration";
import profession from "../../api/configuration";
import category from "../../api/configuration";
export default {
  data() {
    return {
      // 门类列表
      cateList: [],
      proClassList: [],
      proInfoList: [],
      code: "105001",
      proClassCode: "10500101",
      proName: "",
      schoolParam: "",
      /**
       * 控制图表的展示
       * 1. 学校专业都有或都没有 both
       * 2. 仅有学校 school
       * 3. 仅有专业 major
       * 在点击查询时修改此字段
       */
      type: "both",
      /** 数据是否为空 */
      isEmpty: false,
      paramsWithData: {
        school: "",
        major: "",
      },
    };
  },
  computed: {
    /** 是否展示空数据组件 */
    isShowEmpty() {
      return this.isEmpty || this.isFilterParamNone;
    },
    /** 筛选参数是否全为空 */
    isFilterParamNone() {
      return !this.paramsWithData.school && !this.paramsWithData.major;
    },
    /** 空数据组件的提示文案 */
    emptyDescription() {
      return this.isFilterParamNone
        ? "请从左侧选择专业或在右上角输入学校进行查询"
        : "暂无数据";
    },
  },
  methods: {
    // 专业信息
    getProfession(code) {
      profession.getProfession(code).then((res) => {
        this.professionInfo = res.professionInfo;
        this.schoolList = res.professionInfo.highIndexSchoolsList;
        this.professionSatisfaction = res.professionInfo.professionSatisfaction;
        this.graduationSize = res.professionInfo.graduationSize;
        this.malePercent = res.professionInfo.malePercent;
        this.femalePercent = res.professionInfo.femalePercent;
        this.people = res.professionInfo.graduationSize;
        this.option03.series[0].data[0].value = this.malePercent;
        this.option03.series[0].data[1].value = this.femalePercent;
      });
    },
    // // 获取满意度
    // getProfessionSatisfaction(code) {
    //   estimate.getProfessionSatisfaction(code).then((res) => {
    //     this.satiList = res.list[0];
    //     this.option01.series[0].data[0].value = [];
    //     if (this.satiList.length != 0) {
    //       this.option01.series[0].data[0].value[0] =
    //         this.satiList.overallSatisfaction;
    //       this.option01.series[0].data[0].value[1] =
    //         this.satiList.conditionSatisfaction;
    //       this.option01.series[0].data[0].value[2] =
    //         this.satiList.teachQualitySatisfaction;
    //       this.option01.series[0].data[0].value[3] =
    //         this.satiList.workingSatisfaction;
    //     }
    //   });
    // },
    // // 获取薪资
    // getSalaryAndPosition(code) {
    //   this.position = [];
    //   this.avgSalary = [];
    //   estimate.getSalaryAndPosition(code).then((res) => {
    //     this.option02.xAxis.data = [];
    //     this.option02.series[0].data = [];
    //     this.salaryList = res.list;
    //     if (this.salaryList.length != 0) {
    //       for (var i = 0; i < this.salaryList.length; i++) {
    //         this.option02.xAxis.data[i] = this.salaryList[i].position;
    //         this.option02.series[0].data[i] = this.salaryList[i].salary;
    //       }
    //     }
    //   });
    // },
    // //初始化echarts
    // echartsInit() {
    //   //因为初始化echarts 的时候，需要指定的容器 id='main'
    //   this.$echarts
    //     .init(document.getElementById("right01"))
    //     .setOption(this.option01);
    //   this.$echarts
    //     .init(document.getElementById("right02"))
    //     .setOption(this.option02);
    //   this.$echarts
    //     .init(document.getElementById("middle01"))
    //     .setOption(this.option03);
    // },
    getCategory() {
      category.getCategory().then((res) => {
        this.cateList = res.list;
      });
    },
    getProfessionClassByCode(code) {
      category.getProfessionClassByCode(code).then((res) => {
        this.proClassList = res.list;
      });
    },
    getProfessionInfo(code) {
      category.getProfessionInfoByCode(code).then((res) => {
        this.proInfoList = res.list;
      });
    },
    handleOpen(code) {
      if (code > 999999) {
        this.getProfessionInfo(code);
      } else {
        this.getProfessionClassByCode(code);
      }
    },
    // // 改变专业代码,显示信息
    show(name, e) {
      // debugger
      this.proName = name;
      this.schoolParam = ''
      //   this.getProfessionSatisfaction(e.index);
      //   this.getSalaryAndPosition(e.index);
      //   this.getProfession(e.index);
      //   this.echartsInit();
      this.handleFilter();
    },

    handleDetail() {
      this.$router.push({
        path: "/forecast/detail",
        query: {
          school_name: this.schoolParam,
          major_name: this.proName,
        },
      });
    },

    filterJyl(value) {
      if (typeof value !== "string") {
        value = value.toString();
      }
      if (value.indexOf(".") > -1) {
        if (value.length > 5) {
          value = value.slice(0, 5);
        }
      }
      return value;
    },

    renderLeftEchartsBySchool(y = [], byrs = [], jyrs = [], isMajor = false) {
      // 基于准备好的dom，初始化echarts实例
       this.$nextTick(function () { 
      let echarts = this.$echarts.init(
        document.getElementById(isMajor ? "leftMajor" : "leftSchool")
      );
       
      //准备数据
      let option = {
        title: {
          top: 0,
          text: `${
            isMajor ? this.paramsWithData.major : this.paramsWithData.school
          }就业率TOP10`,
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          top: 25,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: "category",
          scale: true,
          data: y,
          //["2016", "2017", "2018", "2019"],
        },
        series: [
          {
            name: "毕业人数",
            type: "bar",
            data: byrs,
            // [500, 489, 450, 560],
          },
          {
            name: "就业人数",
            type: "bar",
            data: jyrs,
            // [450, 438, 431, 520],
          },
        ],
      };
      // 绘制图表
      echarts.setOption(option);
       })
    },

    renderRightEchartsBySchool(data = [], isMajor = false) {
      // 基于准备好的dom，初始化echarts实例
      this.$nextTick(function () { 
      let echarts = this.$echarts.init(
        document.getElementById(isMajor ? "rightMajor" : "rightSchool")
      );
      //准备数据
      let option = {
        title: {
          top: 0,
          text: `${
            isMajor ? this.paramsWithData.major : this.paramsWithData.school
          }就业率TOP10`,
          left: "center",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        tooltip: {
          trigger: "item",
          formatter: (data) => {
            const { name, value, seriesName, color } = data;
            const icon = `
              <div style="
                display: inline-block;
                height: 10px;
                width: 10px;
                border-radius: 50%;
                background: ${color};
              "></div>
            `;
            return `${name}<br /> ${icon}${seriesName}: ${this.filterJyl(
              value * 100
            )}%`;
          },
        },
        legend: {
          top: "5%",
          left: "center",
        },
        series: [
          {
            name: "就业率",
            type: "pie",
            top: 30,
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              ...data,
              // { value: 1048, name: 'Search Engine' }
            ],
          },
        ],
      };
      // 绘制图表
      echarts.setOption(option);
      }
      )
    },

    renderLeftEchartsByBoth(y, byrs, jyrs) {
      this.$nextTick(function () { 
      const echarts = this.$echarts.init(document.getElementById("leftBoth"));

      const option = {
        title: {
          top: 0,
          text: `${this.paramsWithData.school}${this.paramsWithData.major}就业率TOP10`,
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          top: 25,
        },
        grid: {
          left: "15%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: "category",
          scale: true,
          data: y,
        },
        series: [
          {
            name: "毕业人数",
            type: "bar",
            data: byrs,
          },
          {
            name: "就业人数",
            type: "bar",
            data: jyrs,
          },
        ],
      };
      echarts.setOption(option);
      })
    },

    renderRightEchartsByBoth(x = [], jyl = []) {
      this.$nextTick(function () { 
      const echarts = this.$echarts.init(document.getElementById("rightBoth"));
      const option = {
        title: {
          top: 0,
          text: `${this.paramsWithData.school}${this.paramsWithData.major}就业率TOP10`,
          left: "center",
        },
        legend: {
          show: true,
          data: ["就业率"],
          top: 25,
        },
        grid: {
          left: "3%",
          right: "20%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: x,
        },
        tooltip: {
          trigger: "axis",
          formatter: (data) => {
            const { name, value, seriesName } = data[0];
            const icon = `
              <div style="
                display: inline-block;
                height: 10px;
                width: 10px;
                border-radius: 50%;
                background: rgb(194,85,82);
              "></div>
            `;
            return `${name}<br /> ${icon}${seriesName}: ${this.filterJyl(
              value * 100
            )}%`;
          },
        },
        yAxis: {
          type: "value",
          max: 1,
          axisLabel: {
            show: true,
            interval: "auto",
            formatter: (value) => this.filterJyl(value * 100) + "%",
            // "{value} %",
          },
          show: true,
          scale: true,
        },
        series: [
          {
            name: "就业率",
            data: jyl,
            type: "line",
          },
        ],
      };
      echarts.setOption(option);
      })
    },

    renderLeftEchartsByMajor() {
      // this.$nextTick(function () { 
      this.renderLeftEchartsBySchool(...arguments, true);
      // })
    },

    renderRightEchartsByMajor() {
      // this.$nextTick(function () { 
      this.renderRightEchartsBySchool(...arguments, true);
      // })
    },

    setEmpty(data) {
      this.isEmpty = false;
      if (data.length === 0) return (this.isEmpty = true);
    },

    // 查询时进行再次校验
    handleFilter() {
      const schoolParam = this.schoolParam;
      const majorParam = this.proName;
      this.paramsWithData = {
        school: schoolParam,
        major: majorParam,
      };
      if (schoolParam && !majorParam) {
        this.type = "school";

        ForecastService.ProRank({
          school_name: schoolParam,
        }).then((res) => {
          const data = res[0];
          const axis = [];
          const byrs = [];
          const jyrs = [];
          const pieData = [];
          this.setEmpty(data);
          data.forEach((item, index) => {
            if (index <= 9) {
              axis.push(item.zymc);
              byrs.push(item.byrs);
              jyrs.push(item.jyrs);
              pieData.push({ value: parseFloat(item.jyl), name: item.zymc });
            }
          });
          // this.$nextTick(function () { 
            this.renderLeftEchartsBySchool(axis, byrs, jyrs);
            this.renderRightEchartsBySchool(pieData);
          // })
        });
      } else if (schoolParam && majorParam) {
        this.type = "both";
        ForecastService.ProRank({
          school_name: schoolParam,
          major_name: majorParam,
        }).then((res) => {
          const data = res[0];
          const axis = [];
          const byrs = [];
          const jyrs = [];
          const pieData = [];
          this.setEmpty(data);
          data.forEach((item, index) => {
            if (index <= 9) {
              axis.push(item.year);
              byrs.push(item.byrs);
              jyrs.push(item.jyrs);
              pieData.push({ value: parseFloat(item.jyl), name: item.zymc });
            }
          });
          // this.$nextTick(function () { 
            this.renderLeftEchartsByBoth(axis, byrs, jyrs);
            this.renderRightEchartsByBoth(axis, pieData);
          // })
        });
      } else if (!schoolParam && majorParam) {
        this.type = "major";

        ForecastService.ProRank({
          major_name: majorParam,
        }).then((res) => {
          const data = res[0];
          const axis = [];
          const byrs = [];
          const jyrs = [];
          const pieData = [];
          this.setEmpty(data);
          data.forEach((item, index) => {
            if (index <= 9) {
              axis.push(item.xxmc);
              byrs.push(item.byrs);
              jyrs.push(item.jyrs);
              pieData.push({ value: parseFloat(item.jyl), name: item.xxmc });
            }
          });
          // this.$nextTick(function () { 
            this.renderLeftEchartsByMajor(axis, byrs, jyrs);
            this.renderRightEchartsByMajor(pieData);
          // })
        });
      }
    },
  },
  mounted() {
    // this.getProfessionSatisfaction(this.proCode);
    // this.getSalaryAndPosition(this.proCode);
    // this.getProfession(this.proCode);
    this.getCategory();
    // this.renderLeftEchartsByBoth(
    //   ["2016", "2017", "2018", "2019"],
    //   [110, 110, 110, 110],
    //   [110, 110, 110, 110]
    // );
    // this.renderRightEchartsByBoth(
    //   ["2016", "2017", "2018", "2019"],
    //   [0.97, 0.98, 0.99, 1]
    // );
  },
};
</script>

<style scoped lang="less">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
ul {
  list-style: none;
}
.estimate {
  height: 100vh;
  overflow: auto;
}
.app {
  width: 80%;
  margin: 10px 200px;
}
.bd .bd-left {
  width: 200px;
  position: absolute;
  top: 90px;
  left: 0;
  height: 100vh;
  overflow: auto;
}

.proName {
  position: absolute;
  left: 30px;
  top: 0px;
  font-size: 24px;
  color: #000;
  font-weight: 400;
}

.title {
  width: 100%;
  height: 80px;
  background-image: url(../../assets/img/query06.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: auto;
  background-position: 0 -100px;
  text-align: center;
  line-height: 80px;
  font-size: 32px;
  color: black;
  letter-spacing: 20px;
  opacity: 0.8;
}
.filter-line {
  text-align: right;
  margin-bottom: 20px;
  &__input {
    width: 250px;
  }
  &__confirm {
    height: 40px;
    width: 50px;
    margin-left: 10px;
  }
}
.more {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 80px;
}
.data-empty {
  height: 500px;
}
</style>